export namespace TranslationKeysUtil {
  export function getPageTitle(pagePath: string): string {
    let translationKeyPart: string;

    translationKeyPart = pagePath.slice(1);
    translationKeyPart = translationKeyPart.split('#')[0];
    translationKeyPart = translationKeyPart.replace(/\//g, '.');
    translationKeyPart = translationKeyPart.replace(/-|\s/g, '_');
    translationKeyPart = translationKeyPart.toUpperCase();

    const translationKey = `PAGES.${translationKeyPart}.TITLE`;
    return translationKey;
  }

  export function getErrorMessage(errorName: string, fieldName?: string): string {
    let translationKey: string;

    if (fieldName) {
      translationKey = `REGULAR.ERROR_MESSAGES.${fieldName.toUpperCase()}.${errorName.toUpperCase()}`;
    } else {
      translationKey = `REGULAR.ERROR_MESSAGES.${errorName.toUpperCase()}`;
    }

    return translationKey;
  }
}
